import React from "react";
import BlogsSlider from "./BlogsSlider";
import Header from "../common/Header";
const BlogDescription = () => {
  const cardData = JSON.parse(localStorage.getItem("items"));
  console.log("cardDatacardDatacardData", cardData);
  return (
    <>
      <div className="bg-white overflow-x-hidden shadow-my_contacts_tabs_shadow rounded-2xl 3xl:w-full h-[calc(100vh-32px)] px-3 md:px-5">
        <div className=" overflow-hidden">
          <Header text="Blog" />
        </div>
        <div className="   py-6 flex flex-col lg:flex-row">
          <div className="max-w-full sm:max-w-[400px] lg:max-w-[340px] 2xl:max-w-[410px] lg:pr-4 xl:pr-7">
            <img
              src={cardData.blogimg1}
              alt="bolg description"
              className="w-full rounded-[13px]"
            />
            <p className="text-base font-semibold text-black italic mt-4 xl:mt-6">
              "{cardData.blogheading2}"
            </p>
          </div>
          <div className="w-full mt-5 lg:mt-0 overflow-y-auto overflow_x_scroll_style h-full lg:h-[calc(100vh-160px)] overflow-x-hidden pr-2 xl:pr-20">
            <div className=" max-w-full sm:max-w-[640px] md:max-w-full lg:max-w-[600px] xl:max-w-[700px] 2xl:max-w-full">
              <h5 className="text-xl xl:text-2xl font-bold text-black">
                {cardData.blogheading3}
              </h5>
              <p className="text-lg xl:text-xl font-normal italic text-black pt-2 sm:pt-3 xl:pt-6 mt-1">
                " {cardData.blogpara} "
              </p>
              <p className="text-sm font-normal text-black pt-3 sm:pt-5 xl:pt-10">
                {cardData.blogpara3}
              </p>
              <p className="text-sm font-normal text-black pt-4">
                {cardData.blogpara4}
              </p>
              <p className="text-sm font-normal text-black pt-4">
                {cardData.blogpara5}
              </p>
              <p className="text-sm font-normal text-black pt-4">
                {cardData.blogpara6}
              </p>
            </div>
           <div className=" max-w-full sm:max-w-[640px] md:max-w-full lg:max-w-[600px] xl:max-w-[700px] 3xl:max-w-[1000px] min-[1800px]:max-w-[1200px] pt-5 xl:pt-12 ">
              <BlogsSlider />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogDescription;
